<template>
  <div class="core-bright">
    <div class="content-center">
      <div class="module-header">
        <div class="module-title">核心亮点</div>
        <div class="module-subtitle">聚焦项目中心，实现组织级协同与高效执行</div>
      </div>
      <div class="module-body">
        <div class="nav-container">
          <div class="nav-item" :class="{ active: index == activeIdx }" v-for="(item, index) in dataList" :key="item.id" @click="handleScrollTo(index)">
            <img class="nav-item-icon" :src="require(`@/assets/img/home/CoreBright/icon_${item.id}.png`)">
            <span>{{ item.name }}</span>
          </div>
        </div>
        <div class="content-container">
          <div class="bright-item-box" ref="brightItems" v-for="item in dataList" :key="item.id">
            <div class="bright-item" :style="{ backgroundImage: `url(${require(`@/assets/img/home/CoreBright/item_bg_${item.id}.png`)})` }">
              <div class="bright-item-title">{{ item.name }}</div>
              <div class="bright-item-remark">{{ item.remark }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dataList: [
        { id: 'rwxt', name: '任务协同', remark: '让每一个项目人员任务清晰，协作更加方便简单，多方消息可以实时互通，所有沟通协作围绕任务展开。' },
        { id: 'zjaq', name: '资金安全', remark: '每个合作人都拥有自己的银行账户，所有动账全流程可溯源，保证资金绝对安全。' },
        { id: 'bzly', name: '保障履约', remark: '围绕合同，分为收支两条线，更清晰、更好管。' },
      ],
      boxs: [],
      items: [],
      activeIdx: 0
    }
  },
  mounted() {
    this.boxs = this.$refs['brightItems'];
    this.items = this.boxs.map(v => v.firstChild);
    document.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      const tops = this.boxs.map(v => v.getBoundingClientRect()?.top);
      for (let i = 0; i < this.boxs.length - 1; i++) {
        this.items[i].style.transform = `scale(${100 - (tops[i] - tops[i + 1] + 548) / 548 * 8}%)`
      }
    },
    handleScrollTo(index) {
      const box = this.boxs[index];
      this.activeIdx = index;
      box.scrollIntoView({ behavior: 'smooth' });
      setTimeout(() => {
        this.activeIdx = 0;
      }, 500);
    }
  }
};
</script>

<style lang="less" scoped>
.core-bright {
  padding: 64px 0;
  background-color: #fff;

  .content-center {
    .module-body {
      .nav-container {
        margin-top: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        z-index: 1;
        .nav-item {
          width: 182px;
          height: 68px;
          border-radius: 34px;
          border: 1px solid #237CFF;
          color: #666;
          font-family: @font-medium;
          font-size: 18px;
          filter: grayscale(100%);
          cursor: pointer;
          user-select: none;
          display: flex;
          justify-content: center;
          align-items: center;
          &:nth-child(2) {
            border-color: #FFB044;
          }
          &:nth-child(3) {
            border-color: #1CE09F;
          }
          &.active {
            filter: none;
            color: @default-color;
          }
          + .nav-item {
            margin-left: 105px;
          }
          .nav-item-icon {
            width: 24px;
            height: 24px;
            margin-right: 12px;
          }
        }
      }
      .content-container {
        margin-top: 32px;
        position: relative;
        .bright-item-box {
          margin-top: -112px;
          padding-top: 112px;
          position: sticky;
          top: 0;
          + .bright-item-box {
            margin-top: -72px;
          }
          .bright-item {
            width: 1280px;
            height: 498px;
            padding: 163px 0 0 64px;
            background-size: 100% 100%;
            .bright-item-title {
              font-family: @font-medium;
              font-size: 24px;
            }
            .bright-item-remark {
              width: 264px;
              margin-top: 16px;
              color: #666;
              line-height: 28px;
            }
          }
        }
      }
    }
  }
}
</style>
